import { AlarmSubscriptionsForUser } from '@api-model/models';
import { LoadingState, handleFulfilledAction, handleMultipleLoadingActions } from '@hwm/ui-lib';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { thunks } from './AlarmSubscriptionsThunks';
import { actionInterceptor } from '../middleware/actionsInterceptorMiddleware';

interface AlarmSubscriptionsStateModel extends LoadingState {
  alarmSubscriptions?: AlarmSubscriptionsForUser;
}

const initialState: AlarmSubscriptionsStateModel = {
  alarmSubscriptions: null,
  loadingPending: 0,
  error: null,
};

const slice = createSlice({
  name: 'alarmSubscriptions',
  initialState,
  reducers: {
    setSubscriptionState: (state, { payload }: PayloadAction<AlarmSubscriptionsForUser>) => {
      state.alarmSubscriptions = payload;
    },
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions(
      [thunks.getByClaims, thunks.handleSubscribeAlarmsForAccount, thunks.handleSubscribeAlarmsForSite],
      builder
    );
    handleFulfilledAction(thunks.getByClaims, builder, (state, payload) => {
      state.alarmSubscriptions = payload;
    });
    handleFulfilledAction(thunks.handleSubscribeAlarmsForAccount, builder, (state, payload: { subscribe: boolean }) => {
      state.alarmSubscriptions = {
        isSubscribedForAccount: payload.subscribe,
        siteIds: null,
      };
    });
    handleFulfilledAction(
      thunks.handleSubscribeAlarmsForSite,
      builder,
      (state, payload: { siteId: number | string; subscribe: boolean }) => {
        if (state.alarmSubscriptions?.isSubscribedForAccount) return;

        const payloadSiteId = Number(payload.siteId);

        const currentSiteIds = Boolean(state.alarmSubscriptions?.siteIds) ? [...state.alarmSubscriptions.siteIds] : [];

        state.alarmSubscriptions = {
          isSubscribedForAccount: false,
          siteIds: payload.subscribe
            ? [...currentSiteIds, payloadSiteId]
            : currentSiteIds.filter((sId) => sId !== payloadSiteId),
        };
      }
    );
  },
});

export const alarmSubscriptionsReducer = {
  slice,
  thunks,
};

actionInterceptor.addActionsCallback<typeof alarmSubscriptionsReducer.thunks.handleSubscribeAlarmsForAccount.fulfilled>(
  {
    actionTypes: [alarmSubscriptionsReducer.thunks.handleSubscribeAlarmsForAccount.fulfilled.type],
    callback: ({ dispatch }) => {
      dispatch(alarmSubscriptionsReducer.thunks.getByClaims());
    },
  }
);

actionInterceptor.addActionsCallback<typeof alarmSubscriptionsReducer.thunks.handleSubscribeAlarmsForSite.fulfilled>({
  actionTypes: [alarmSubscriptionsReducer.thunks.handleSubscribeAlarmsForSite.fulfilled.type],
  callback: ({ dispatch }) => {
    dispatch(alarmSubscriptionsReducer.thunks.getByClaims());
  },
});
